var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var EditIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 42,
    glyphHeight: 42
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8181 8.87068L3.31168 25.4203C2.98131 25.7514 2.75222 26.1721 2.65817 26.6314L0.05138 39.0859C-0.115011 39.8812 0.128546 40.7079 0.697651 41.2833C1.26917 41.861 2.08907 42.1125 2.88485 41.9529L15.41 39.4436C15.8754 39.3494 16.3046 39.1197 16.6423 38.7813L33.1487 22.2341L19.8181 8.87068ZM23.2304 5.45246L36.5585 18.8159L39.2401 16.1302C42.92 12.4388 42.92 6.45811 39.2401 2.76914C39.2377 2.76914 39.2377 2.76672 39.2377 2.76672C35.5554 -0.922241 29.5894 -0.922241 25.9095 2.76672L23.2304 5.45246Z"
  }));
};
export var EditIconGlyph = function (props) {
  return React.createElement(EditIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};